export default import.meta.ROLLDOWN_FILE_URL_gsv6ob6icZuqjPfpD2W2Qw